module.exports = __webpack_public_path__ + "img/retaining-wall-2.29acab87.jpeg";